import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Flame, Trophy } from "lucide-react";

export default function ChantStreakCard() {
  const [stats, setStats] = useState(null);

  useEffect(() => { api.get("/chants/stats").then((r) => setStats(r.data)).catch(() => {}); }, []);

  if (!stats) return null;

  const earned = stats.badges.filter((b) => b.earned);
  const next = stats.next_badge;
  const progress = next ? Math.min(100, Math.round((stats.current_streak / next.min_streak) * 100)) : 100;

  return (
    <div data-testid="chant-streak-card" className="bg-gradient-to-br from-[#4A0E17] to-[#36080F] text-[#FAF6F0] rounded-3xl p-7 relative overflow-hidden">
      <div className="absolute -right-5 -top-10 font-devanagari text-[200px] leading-none text-[#D4AF37] opacity-10 pointer-events-none select-none">ॐ</div>
      <div className="relative">
        <div className="flex items-start justify-between">
          <div>
            <div className="overline text-[#D4AF37]">Chant Streak</div>
            <div className="font-serif text-5xl font-semibold mt-2 flex items-baseline gap-2">
              {stats.current_streak}
              <span className="text-xl font-sans text-[#F3E5AB]/80">day{stats.current_streak !== 1 ? "s" : ""}</span>
            </div>
            <div className="flex items-center gap-2 mt-1 text-sm text-[#F3E5AB]/70">
              <Flame className="w-4 h-4 text-[#E65100]" />
              Longest: {stats.longest_streak} · Total chants: {stats.total_chants}
            </div>
          </div>
          <div className="text-right">
            <div className="overline text-[#D4AF37]">Badges</div>
            <div className="flex gap-2 mt-2">
              {stats.badges.map((b) => (
                <div
                  key={b.key}
                  data-testid={`badge-${b.key}`}
                  title={`${b.title} — ${b.description}`}
                  className={`w-10 h-10 rounded-full flex items-center justify-center text-xl transition-sacred ${b.earned ? "bg-[#D4AF37] text-[#4A0E17] shadow-lg" : "bg-white/5 text-[#F3E5AB]/30 border border-[#F3E5AB]/20"}`}
                >
                  {b.icon}
                </div>
              ))}
            </div>
          </div>
        </div>

        {next && (
          <div className="mt-6">
            <div className="flex items-center justify-between text-xs text-[#F3E5AB]/80 mb-2">
              <span className="flex items-center gap-1.5"><Trophy className="w-3.5 h-3.5 text-[#D4AF37]" /> Next: <strong className="text-[#F3E5AB]">{next.title} {next.icon}</strong></span>
              <span className="font-mono">{stats.current_streak}/{next.min_streak}</span>
            </div>
            <div className="h-2 bg-white/10 rounded-full overflow-hidden">
              <div
                data-testid="badge-progress-bar"
                className="h-full bg-gradient-to-r from-[#E65100] to-[#D4AF37]"
                style={{ width: `${progress}%` }}
              />
            </div>
            <p className="text-xs text-[#F3E5AB]/60 mt-2 italic">{next.description}</p>
          </div>
        )}

        {earned.length > 0 && (
          <div className="mt-5 pt-5 border-t border-[#D4AF37]/20">
            <div className="overline text-[#D4AF37]">Earned</div>
            <div className="mt-2 flex flex-wrap gap-2">
              {earned.map((b) => (
                <span key={b.key} className="inline-flex items-center gap-1.5 bg-[#D4AF37]/15 border border-[#D4AF37]/30 rounded-full px-3 py-1 text-xs text-[#F3E5AB]">
                  <span>{b.icon}</span> {b.title}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
